import script from "./OfferModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./OfferModal.vue?vue&type=script&lang=ts&setup=true"

import "./OfferModal.vue?vue&type=style&index=0&id=2ad983ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad983ac"]])

export default __exports__